import store from 'store2';
export const appStoreCredentials = store.namespace('credentials');
export const app_store_credentials_is_logged_in = appStoreCredentials.has('uuid') && appStoreCredentials.has('token');
export const app_store_credentials_is_profile_logged_in = appStoreCredentials.has('profile-uuid');
//# sourceMappingURL=credentials.js.map